<template>
  <p-dialog 
    :visible="visible" 
    :modal="true" 
    :closable="false" 
    :showHeader="false" 
    class="tool-restriction-dialog"
    @hide="onCancel"
  >
    <div class="modal-content-wrapper">
      <!-- Close Button -->
      <button class="close-btn" @click="onCancel">
        <i class="pi pi-times"></i>
      </button>

      <div class="header-section">
        <div class="crown-icon">👑</div>
        <h2 class="title">Unlock Unlimited Potential</h2>
        <p class="subtitle">You can only use 3 unique drawing tools or indicators at once on the free plans</p>
      </div>

      <div class="premium-feature-grid">
        <div class="feature-item">
          <i class="pi pi-check-circle"></i>
          <span>Unlimited Drawing Tools</span>
        </div>
        <div class="feature-item">
          <i class="pi pi-check-circle"></i>
          <span>Unlimited Technical Indicators</span>
        </div>
        <div class="feature-item">
          <i class="pi pi-check-circle"></i>
          <span>Advanced Charting Features</span>
        </div>
        <div class="feature-item">
          <i class="pi pi-check-circle"></i>
          <span>Real-time Market Data</span>
        </div>
      </div>

      <div class="cta-section">
        <button class="upgrade-btn" @click="onUpgrade">
          Upgrade to Premium <i class="pi pi-arrow-right"></i>
        </button>
        <button class="cancel-btn" @click="onCancel">Maybe Later</button>
      </div>
    </div>
  </p-dialog>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'ToolRestrictionModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['getUserId'])
  },
  methods: {
    ...mapMutations(['SET_TOOL_RESTRICT_POPUP', 'SET_AUTH_MODAL']),
    onCancel() {
      this.SET_TOOL_RESTRICT_POPUP(false)
    },
    onUpgrade() {
      this.SET_TOOL_RESTRICT_POPUP(false)
      if (this.getUserId) {
        this.$router.push({ name: 'products' })
      } else {
        this.SET_AUTH_MODAL(true)
      }
    }
  }
}
</script>

<style scoped>
:deep(.p-dialog.tool-restriction-dialog) {
    background: #fff !important;
    border: none;
    border-radius: 24px;
    box-shadow: 0 20px 50px rgba(0,0,0,0.3);
    overflow: hidden;
    width: 450px;
    max-width: 90vw;
}

:deep(.p-dialog-content) {
    background: #fff !important;
    padding: 0 !important;
}

.modal-content-wrapper {
  background: linear-gradient(135deg, #ffffff 0%, #f9f9f9 100%);
  padding: 3rem 2rem 2rem;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.close-btn {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: rgba(0,0,0,0.05);
  border: none;
  color: #333;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.close-btn:hover {
  background: rgba(0,0,0,0.1);
  /* transform: rotate(90deg); */
}

.header-section {
  margin-bottom: 2rem;
}

.crown-icon {
  font-size: 3.5rem;
  margin-bottom: 1rem;
  filter: drop-shadow(0 4px 8px rgba(244, 180, 0, 0.3));
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}

.title {
  font-size: 1.8rem;
  font-weight: 800;
  color: #1a1a1a;
  margin-bottom: 0.5rem;
  line-height: 1.2;
}

.subtitle {
  font-size: 1rem;
  color: #666;
  max-width: 300px;
}

.premium-feature-grid {
  width: 100%;
  background: rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(0,0,0,0.05);
  border-radius: 16px;
  padding: 1.5rem;
  margin-bottom: 2rem;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 0.95rem;
  color: #333;
  font-weight: 500;
}

.feature-item i {
  color: #4CAF50;
  font-size: 1.1rem;
}

.cta-section {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.upgrade-btn {
  background: linear-gradient(135deg, #db2828 0%, #b71c1c 100%);
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 14px;
  font-weight: 700;
  font-size: 1.1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  box-shadow: 0 8px 20px rgba(219, 40, 40, 0.3);
}

.upgrade-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 25px rgba(219, 40, 40, 0.4);
}

.upgrade-btn:active {
  transform: translateY(0);
}

.cancel-btn {
  background: transparent;
  border: none;
  color: #888;
  font-weight: 600;
  cursor: pointer;
  font-size: 0.9rem;
  transition: color 0.2s;
}

.cancel-btn:hover {
  color: #333;
}
</style>